import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { memo, useCallback, useEffect, useRef } from "react";
import lIsEqual from "lodash.isequal";
import { useJWPlayer } from "../JWPlayerContext";
import { VolumeControl } from "../PlayerControls";
const streamPlayerOptions = {
    advertising: {
        autoplayadsmuted: false,
        outstream: false
    },
    aspectratio: "16:9",
    autoPause: {
        viewability: false
    },
    autostart: "viewable",
    controls: false,
    allowFullscreen: true,
    displayHeading: false,
    displaydescription: true,
    displaytitle: true,
    floating: {
        mode: "never"
    },
    generateSEOMetadata: false,
    include_compatibility_script: false,
    intl: {
        en: {}
    },
    logo: {
        hide: true,
        position: "top-right"
    },
    mute: true,
    pipIcon: "disabled",
    playbackRateControls: false,
    preload: "metadata",
    repeat: true,
    width: "100%",
    nextUpDisplay: false
};
export const StreamPlayer = /*#__PURE__*/ memo((param)=>{
    let { stream , options , uniquePlayerId  } = param;
    const isInitialPlayerReady = useRef(true);
    const isInitialSeek = useRef(true);
    const jwplayer = useJWPlayer();
    const playerRef = useRef(null);
    useEffect(()=>{
        if (!jwplayer || playerRef.current) return;
        playerRef.current = jwplayer(uniquePlayerId).setup({
            playlist: stream.playlist,
            image: stream.thumbnail,
            ...streamPlayerOptions,
            ...options
        });
    }, [
        jwplayer
    ]);
    useEffect(()=>{
        if (!playerRef.current) return;
        playerRef.current.on("ready", ()=>{
            if (!isInitialPlayerReady) return;
            setTimeout(()=>{
                playerRef.current.playlistItem(stream.playlistItemIndex);
                isInitialPlayerReady.current = false;
            }, 0);
        });
        playerRef.current.on("playlistItem", ()=>{
            if (!isInitialSeek) return;
            setTimeout(()=>{
                playerRef.current.seek(stream.timestamp);
                isInitialSeek.current = false;
            }, 0);
        });
    }, [
        stream,
        options,
        jwplayer
    ]);
    const onMute = useCallback((isMute)=>{
        if (!playerRef.current) return;
        playerRef.current.setMute(isMute);
    }, [
        playerRef.current
    ]);
    const onVolumeChange = useCallback((volume)=>{
        if (!playerRef.current) return;
        playerRef.current.setVolume(volume);
    }, [
        playerRef.current
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                id: uniquePlayerId
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "absolute bottom-2 left-2 text-white md:left-auto md:right-4 md:bottom-4",
                children: /*#__PURE__*/ _jsx(VolumeControl, {
                    onMute: onMute,
                    onVolumeChange: onVolumeChange,
                    defaultValues: {
                        isMute: streamPlayerOptions.mute
                    }
                })
            })
        ]
    });
}, isEqual);
function isEqual(prevProps, nextProps) {
    return lIsEqual({
        playlist: prevProps.stream.playlist,
        playlistItemIndex: prevProps.stream.playlistItemIndex,
        thumbnail: prevProps.stream.thumbnail
    }, {
        playlist: nextProps.stream.playlist,
        playlistItemIndex: nextProps.stream.playlistItemIndex,
        thumbnail: nextProps.stream.thumbnail
    });
}
